"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeNotificationByIdApi = exports.markNotificationAsReadApi = exports.getUnreadNotifcationsApi = exports.getNotificationByIdApi = exports.getAllNotifcationsApi = void 0;

var _invoke = _interopRequireDefault(require("../../util/invoke"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {String} basePath
 * @param {String} authToken
 * @param {String} projectKey
 * @param {Number} page
 * @returns {Promise}
 */
const getAllNotifcationsApi = function getAllNotifcationsApi(basePath, authToken, projectKey) {
  let page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return (0, _invoke.default)({
    method: 'GET',
    url: "".concat(basePath, "/v2/notifications/list/all/?page=").concat(page),
    headers: {
      Authorization: "".concat(authToken),
      'platform-subscriber-id': projectKey
    }
  });
};
/**
 * @param {String} basePath
 * @param {String} authToken
 * @param {String} projectKey
 * @param {Number} page
 * @returns {Promise}
 */


exports.getAllNotifcationsApi = getAllNotifcationsApi;

const getUnreadNotifcationsApi = function getUnreadNotifcationsApi(basePath, authToken, projectKey) {
  let page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return (0, _invoke.default)({
    method: 'GET',
    url: "".concat(basePath, "/v2/notifications/list/unread/?page=").concat(page),
    headers: {
      Authorization: "".concat(authToken),
      'platform-subscriber-id': projectKey
    }
  });
};
/**
 * @param {String} basePath
 * @param {String} authToken
 * @param {String} projectKey
 * @param {Number} page
 * @returns {Promise}
 */


exports.getUnreadNotifcationsApi = getUnreadNotifcationsApi;

const getNotificationByIdApi = function getNotificationByIdApi(basePath, authToken, projectKey) {
  let id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return (0, _invoke.default)({
    method: 'GET',
    url: "".concat(basePath, "/v2/notifications/up/get/").concat(id, "/"),
    headers: {
      Authorization: "".concat(authToken),
      'platform-subscriber-id': projectKey
    }
  });
};
/**
 * @param {String} basePath
 * @param {String} authToken
 * @param {String} projectKey
 * @param {Number} page
 * @returns {Promise}
 */


exports.getNotificationByIdApi = getNotificationByIdApi;

const markNotificationAsReadApi = function markNotificationAsReadApi(basePath, authToken, projectKey) {
  let id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return (0, _invoke.default)({
    method: 'PUT',
    url: "".concat(basePath, "/v2/notifications/up/read/").concat(id, "/"),
    headers: {
      Authorization: "".concat(authToken),
      'platform-subscriber-id': projectKey
    }
  });
};
/**
 * @param {String} basePath
 * @param {String} authToken
 * @param {String} projectKey
 * @param {Number} page
 * @returns {Promise}
 */


exports.markNotificationAsReadApi = markNotificationAsReadApi;

const removeNotificationByIdApi = function removeNotificationByIdApi(basePath, authToken, projectKey) {
  let id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return (0, _invoke.default)({
    method: 'PUT',
    url: "".concat(basePath, "/v2/notifications/up/remove/").concat(id, "/"),
    headers: {
      Authorization: "".concat(authToken),
      'platform-subscriber-id': projectKey
    }
  });
};

exports.removeNotificationByIdApi = removeNotificationByIdApi;